import script from "./OemConfig.vue?vue&type=script&setup=true&lang=ts"
export * from "./OemConfig.vue?vue&type=script&setup=true&lang=ts"

import "./OemConfig.vue?vue&type=style&index=0&id=1fde3d73&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fde3d73"]])

export default __exports__